var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourcePractice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6045_3870)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6045_3870",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 32,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1112 1.29614H1.19922V34.6201H18.8272V33.6841L32.1112 15.0601V1.29614Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6045_3870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.749 10.476L22.957 3.69604V10.476H29.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7473 10.476V27.264C29.7473 30 27.5273 32.22 24.7913 32.22H8.49531C5.84331 32.22 3.69531 30.072 3.69531 27.42V3.69604H22.9673L29.7473 10.476Z",
    stroke: "black",
    strokeWidth: 2.25
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2969 9.85205H20.5569",
    stroke: "black",
    strokeWidth: 2.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2969 16.0559H20.5569",
    stroke: "black",
    strokeWidth: 2.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4005 32.6762L22.8965 34.7042L23.6045 30.7202L31.8725 18.9122C32.1245 18.5642 32.6045 18.4682 32.9645 18.7202L34.4765 19.7762C34.8245 20.0282 34.9205 20.5082 34.6685 20.8682L26.4005 32.6762Z",
    fill: "#E71D2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69648 11.652C10.6906 11.652 11.4965 10.8461 11.4965 9.852C11.4965 8.85789 10.6906 8.052 9.69648 8.052C8.70237 8.052 7.89648 8.85789 7.89648 9.852C7.89648 10.8461 8.70237 11.652 9.69648 11.652Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69648 15.4559C10.0325 15.4559 10.2965 15.7199 10.2965 16.0559C10.2965 16.3919 10.0325 16.6559 9.69648 16.6559C9.36048 16.6559 9.09648 16.3919 9.09648 16.0559C9.09648 15.7199 9.36048 15.4559 9.69648 15.4559ZM9.69648 14.2559C8.70048 14.2559 7.89648 15.0599 7.89648 16.0559C7.89648 17.0519 8.70048 17.8559 9.69648 17.8559C10.6925 17.8559 11.4965 17.0519 11.4965 16.0559C11.4965 15.0599 10.6925 14.2559 9.69648 14.2559Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2969 22.26H20.5569",
    stroke: "black",
    strokeWidth: 2.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69648 21.66C10.0325 21.66 10.2965 21.924 10.2965 22.26C10.2965 22.596 10.0325 22.86 9.69648 22.86C9.36048 22.86 9.09648 22.596 9.09648 22.26C9.09648 21.924 9.36048 21.66 9.69648 21.66ZM9.69648 20.46C8.70048 20.46 7.89648 21.264 7.89648 22.26C7.89648 23.256 8.70048 24.06 9.69648 24.06C10.6925 24.06 11.4965 23.256 11.4965 22.26C11.4965 21.264 10.6925 20.46 9.69648 20.46Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6045_3870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourcePractice);
export default __webpack_public_path__ + "static/media/cource-practice.bc3c15a18118606812e5f7bf0f198b6a.svg";
export { ForwardRef as ReactComponent };